import React from "react";

import "./LandingDesignSystem.css";
import "./LandingComposition.css";

const cx = (...values) => values.filter(Boolean).join(" ");

export const LANDING_CONTAINER_CLASS = "ecotour-landing-container";
export const LANDING_SECTION_CLASS = "ecotour-landing-section";
export const LANDING_FOCUS_CLASS = "ecotour-landing-focus";
export const LANDING_ICON_BUTTON_CLASS =
  "ecotour-landing-icon-button ecotour-landing-focus";

export const LandingPageShell = React.forwardRef(
  ({ as: Component = "div", className = "", children, ...props }, ref) => (
    <Component
      ref={ref}
      className={cx("ecotour-landing-system", className)}
      {...props}
    >
      {children}
    </Component>
  ),
);

LandingPageShell.displayName = "LandingPageShell";

export const LandingSection = React.forwardRef(
  (
    {
      as: Component = "section",
      className = "",
      compact = false,
      children,
      ...props
    },
    ref,
  ) => (
    <Component
      ref={ref}
      className={cx(
        LANDING_SECTION_CLASS,
        compact && "ecotour-landing-section--compact",
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  ),
);

LandingSection.displayName = "LandingSection";

export function LandingSectionHeader({
  title,
  subtitle = "",
  eyebrow = "",
  actions = null,
  titleId,
  className = "",
  copyClassName = "",
  titleClassName = "",
  subtitleClassName = "",
  actionsClassName = "",
}) {
  return (
    <div className={cx("ecotour-landing-section-header", className)}>
      <div className={cx("ecotour-landing-section-header__copy", copyClassName)}>
        {eyebrow ? (
          <p className="ecotour-landing-section-header__eyebrow">{eyebrow}</p>
        ) : null}
        <h2
          id={titleId}
          className={cx("ecotour-landing-section-header__title", titleClassName)}
        >
          {title}
        </h2>
        {subtitle ? (
          <p
            className={cx(
              "ecotour-landing-section-header__subtitle",
              subtitleClassName,
            )}
          >
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div
          className={cx(
            "ecotour-landing-section-header__actions",
            actionsClassName,
          )}
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}

export const LandingCardRail = React.forwardRef(
  ({ as: Component = "div", className = "", children, ...props }, ref) => (
    <Component
      ref={ref}
      className={cx("ecotour-landing-card-rail", className)}
      {...props}
    >
      {children}
    </Component>
  ),
);

LandingCardRail.displayName = "LandingCardRail";

export const LandingCardShell = React.forwardRef(
  (
    {
      as: Component = "div",
      className = "",
      interactive = false,
      children,
      ...props
    },
    ref,
  ) => (
    <Component
      ref={ref}
      className={cx(
        "ecotour-landing-card-shell",
        interactive && "ecotour-landing-card-shell--interactive",
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  ),
);

LandingCardShell.displayName = "LandingCardShell";
